module.exports = __webpack_public_path__ + "static/media/view_black.f9f2faf5.svg";